var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProbabilityPrecipitation01 = function SvgProbabilityPrecipitation01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 617.7 447.61",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 74.98,
    y1: 246.89,
    x2: 458.98,
    y2: -51.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 127.67,
    y1: 314.78,
    x2: 511.67,
    y2: 16.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 28.47,
    y1: 186.95,
    x2: 412.47,
    y2: -111.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 242.52,
    y1: 462.77,
    x2: 626.52,
    y2: 164.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 263.79,
    y1: 490.19,
    x2: 647.79,
    y2: 192.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 177.74,
    y1: 379.3,
    x2: 561.74,
    y2: 81.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 309.87,
    y1: 549.57,
    x2: 693.87,
    y2: 251.57,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M171.78,0C76.91,0,0,76.91,0,171.78s76.91,171.78,171.78,171.78,171.78-76.91,171.78-171.78S266.65,0,171.78,0ZM75.39,143.18c-4.1-6.8-6.15-14.4-6.15-22.8s2.07-16.3,6.23-23.1c4.15-6.8,9.65-12.15,16.5-16.05,6.85-3.9,14.32-5.85,22.42-5.85s15.7,2,22.5,6c6.8,4,12.23,9.4,16.27,16.2,4.05,6.8,6.08,14.4,6.08,22.8s-2.08,16.15-6.23,22.95c-4.15,6.8-9.63,12.15-16.42,16.05-6.8,3.9-14.2,5.85-22.2,5.85s-15.73-1.97-22.57-5.92c-6.85-3.95-12.33-9.32-16.43-16.13ZM130.89,284.18h-42.3l121.2-210h42.3l-121.2,210ZM265.36,260.78c-4.05,6.8-9.5,12.23-16.35,16.28-6.85,4.05-14.43,6.08-22.73,6.08s-15.85-2.07-22.65-6.23c-6.8-4.15-12.2-9.65-16.2-16.5-4-6.85-6-14.22-6-22.12,0-8.6,2.07-16.3,6.22-23.1,4.15-6.8,9.65-12.17,16.5-16.12,6.85-3.95,14.22-5.92,22.12-5.92,8.6,0,16.3,2.1,23.1,6.3,6.8,4.2,12.17,9.73,16.12,16.58,3.95,6.85,5.93,14.28,5.93,22.27s-2.03,15.7-6.08,22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.29,218.18c-5.4,0-10.05,1.95-13.95,5.85-3.9,3.9-5.85,8.65-5.85,14.25s1.95,10.05,5.85,13.95c3.9,3.9,8.55,5.85,13.95,5.85s10.35-1.95,14.25-5.85c3.9-3.9,5.85-8.55,5.85-13.95s-1.95-10.35-5.85-14.25c-3.9-3.9-8.65-5.85-14.25-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.39,140.18c5.4,0,10.05-1.92,13.95-5.77,3.9-3.85,5.85-8.52,5.85-14.02s-1.95-10.3-5.85-14.1c-3.9-3.8-8.55-5.7-13.95-5.7s-10.23,1.9-14.17,5.7c-3.95,3.8-5.93,8.5-5.93,14.1s1.97,10.18,5.93,14.02c3.95,3.85,8.67,5.77,14.17,5.77Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.52,343.87l-27.46,54.08c-2.8,5.16-4.36,10.9-4.54,16.77-.03,8.63,3.3,16.94,9.28,23.17,5.93,6.21,14.14,9.72,22.72,9.73,8.58,0,16.79-3.52,22.72-9.73,5.98-6.23,9.31-14.53,9.28-23.17-.23-5.73-1.72-11.35-4.35-16.45l-27.65-54.4ZM337.02,428.99c-7.48,7.4-19.53,7.4-27.01,0-3.68-3.83-5.73-8.95-5.7-14.27.21-3.69,1.21-7.29,2.94-10.56l16.26-32,16.38,32.13c1.64,3.25,2.6,6.8,2.82,10.43.03,5.32-2.01,10.44-5.7,14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M413.12,318.27l-27.46,54.08c-2.8,5.16-4.36,10.9-4.54,16.77-.03,8.63,3.3,16.94,9.28,23.17,5.93,6.21,14.14,9.72,22.72,9.73,8.58,0,16.79-3.52,22.72-9.73,5.98-6.23,9.31-14.53,9.28-23.17-.23-5.73-1.72-11.35-4.35-16.45l-27.65-54.4ZM426.62,403.39c-7.48,7.4-19.53,7.4-27.01,0-3.68-3.83-5.73-8.95-5.7-14.27.21-3.69,1.21-7.29,2.94-10.56l16.26-32,16.38,32.13c1.64,3.25,2.6,6.8,2.82,10.43.03,5.32-2.01,10.44-5.7,14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555.45,137.4c.31-2.61.46-5.24.45-7.87-.35-37.44-30.97-67.52-68.42-67.2-11.94-.02-23.67,3.07-34.05,8.96-20.14-21.3-48.19-33.34-77.5-33.28-22.19-.16-42.87,6.6-59.94,18.28,2.8,3.23,5.48,6.55,8.05,9.98,14.84-9.92,32.71-15.64,51.9-15.47,27.49-.08,53.62,11.95,71.42,32.9l3.71,4.42,4.74-3.26c9.35-6.34,20.39-9.72,31.68-9.73,30.37-.32,55.26,24.03,55.62,54.4-.02,3.92-.45,7.82-1.28,11.65l-1.54,6.72,6.85,1.02c33.59,4.4,58.49,33.36,57.79,67.23-.75,36.68-31.1,65.81-67.78,65.06h-217.11c-3.59,4.45-7.39,8.72-11.4,12.8h228.5c37.69.62,70.6-25.4,78.69-62.22,9.39-42.74-17.65-85-60.39-94.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M502.72,343.87l-27.46,54.08c-2.8,5.16-4.36,10.9-4.54,16.77-.04,8.64,3.29,16.95,9.28,23.17,5.93,6.21,14.14,9.72,22.72,9.73,8.58,0,16.79-3.52,22.72-9.73,5.98-6.23,9.31-14.53,9.28-23.17-.23-5.73-1.72-11.35-4.35-16.45l-27.65-54.4ZM516.22,428.99c-7.48,7.4-19.53,7.4-27.01,0-3.68-3.83-5.73-8.95-5.7-14.27.21-3.69,1.21-7.29,2.94-10.56l16.26-32,16.38,32.13c1.64,3.25,2.6,6.8,2.82,10.43.03,5.32-2.01,10.44-5.7,14.27Z"
  }))));
};
export default SvgProbabilityPrecipitation01;